import { useLenis } from "@/hooks/useLenis";
import { LanguageProvider } from "@/context/LanguageContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Intro from "@/components/site/Intro";
import MiniStrip from "@/components/site/MiniStrip";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Intimacy from "@/components/site/Intimacy";
import Pricing from "@/components/site/Pricing";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

function SiteContent() {
  useLenis();
  return (
    <div className="grain relative bg-cream min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Intro />
        <MiniStrip />
        <Services />
        <Manifesto />
        <Intimacy />
        <Gallery />
        <Reviews />
        <Pricing />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function Home() {
  return (
    <LanguageProvider>
      <SiteContent />
    </LanguageProvider>
  );
}
